let scrollpos = window.scrollY;
const header = document.getElementById('wrapper-navbar');
let scrollChange = 16 //can we use rem as a value for this in case user is zoomed? Should we try to get the value of the margin and use that instead of a fixed value?

window.addEventListener('load', AWD_StickyNavEffect);
window.addEventListener('scroll', AWD_StickyNavEffect);

function AWD_StickyNavEffect() {
    if(!header) {
        return;
    }
    
    scrollpos = window.scrollY;
    scrollChange = window.innerWidth > 992 ? 16 : 1;

    if (scrollpos >= scrollChange) { 
        header.classList.add('page-scrolled');
    }else { 
        header.classList.remove('page-scrolled');
    }
}

// function AWD_Icon(name) {
//     const $svg = document.createElement('svg');
//     $svg.classList.add('awd-icon');
//     $svg.setAttribute('width', '14');
//     $svg.setAttribute('height', '14');
//     const $use = document.createElement('use');
//     $use.setAttribute('xlink:href', `${awdIconUrl}#${name}`);
//     $svg.appendChild($use);
//     return $svg;
// }

window.addEventListener('DOMContentLoaded', function() {

    const $yoastFaqBlocks = document.querySelectorAll('.wp-block-yoast-faq-block');
        
    if ($yoastFaqBlocks.length) {
        $yoastFaqBlocks.forEach($yoastFaqBlock => {
            const $faqSections = $yoastFaqBlock.querySelectorAll('.schema-faq-section');
            if($faqSections.length) {
                $faqSections.forEach(($faqSection, index) => {
                    const $faqQuestion = $faqSection.querySelector('.schema-faq-question');
                    const $faqAnswer = $faqSection.querySelector('.schema-faq-answer');
                    // // opens first question
                    // if(!index) {
                    //     $faqSection.classList.add('faq-open');
                    //     $faqAnswer.style.height = $faqAnswer.scrollHeight + 'px';
                    // }
                    $faqQuestion.addEventListener('click', function(e) {
                        $faqSection.classList.toggle('faq-open');
                        $faqAnswer.style.height = $faqSection.classList.contains('faq-open') ? $faqAnswer.scrollHeight + 'px' : '0px';
                    });
                });
            }
        });
    }

    const $wpcf7 = document.querySelectorAll('.wpcf7-form');

    if ($wpcf7.length) {
        const $icon = document.createElement('span');
        $icon.classList.add('fasr', 'fa-check', 'awd-icon');
        const $valid = document.createElement('span');
        $valid.setAttribute('role', 'alert');
        $valid.classList.add('valid-input');
        $valid.appendChild($icon);

        if($wpcf7.length) {
            $wpcf7.forEach(function($form) {

                const $requireds = $form.querySelectorAll('.wpcf7-form-control.wpcf7-validates-as-required');
                $requireds.forEach(function($required) {
                    $required.insertAdjacentElement('afterend', $valid.cloneNode(true));
                });
                
                $form.addEventListener('submit', function(event) {
                    const $submits = event.target.querySelectorAll('[type="submit"]');
                    $submits.forEach(function($submit) {
                        const loadingText = 'Submitting...';
                        $submit.disabled = true;
                        if(!$submit.getAttribute('data-button-label')) {
                            $submit.setAttribute('data-button-label', $submit.textContent);
                        }
                        $submit.textContent = loadingText;
                    });
                });

                document.addEventListener( 'wpcf7submit', function( event ) {
                    const $form = event.target;
                    const $submit = $form.querySelector('[type="submit"]');
                    
                    if($submit) {
                        $submit.disabled = false;
                        $submit.textContent = $submit.getAttribute('data-button-label');
                        if(event.detail.status === 'mail_sent') {
                            const $submitIcon = document.createElement('span');
                            $submitIcon.classList.add('fasr', 'fa-check-circle', 'ms-1');
                            $submit.appendChild($submitIcon);
                        }
                    }
                }); 
            });
        }
    }
});